import { Breakpoint, Grid, TimelineItemProps } from 'antd';
import { AxiosResponse } from 'axios';
import { Dispatch, SetStateAction, createContext, useState } from 'react';
import { IHandoverTicket } from 'src/types/office_ticket/handoverTicket.type';

const { useBreakpoint } = Grid;

interface OfficeTicketDetailContextInterface {
  handoverTicket: AxiosResponse<IHandoverTicket, any> | undefined;
  setHandoverTicket: Dispatch<SetStateAction<AxiosResponse<IHandoverTicket, any> | undefined>>;
  loading: boolean;
  setLoading: Dispatch<SetStateAction<boolean>>;
  approvalProcessTimeLine: TimelineItemProps[] | undefined;
  setApprovalProcessTimeLine: Dispatch<SetStateAction<TimelineItemProps[] | undefined>>;
  screens: Partial<Record<Breakpoint, boolean>> | undefined;
}

const initialOfficeTicketDetailContext: OfficeTicketDetailContextInterface = {
  handoverTicket: undefined,
  setHandoverTicket: () => null,
  loading: true,
  setLoading: () => null,
  approvalProcessTimeLine: undefined,
  setApprovalProcessTimeLine: () => null,
  screens: undefined
};

export const OfficeTicketDetailContext = createContext<OfficeTicketDetailContextInterface>(
  initialOfficeTicketDetailContext
);

export const OfficeTicketDetailProvider = ({ children }: { children: React.ReactNode }) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [approvalProcessTimeLine, setApprovalProcessTimeLine] = useState<TimelineItemProps[] | undefined>(undefined);
  const screens = useBreakpoint();

  const [handoverTicket, setHandoverTicket] = useState<AxiosResponse<IHandoverTicket, any> | undefined>(
    initialOfficeTicketDetailContext.handoverTicket
  );

  return (
    <OfficeTicketDetailContext.Provider
      value={{
        handoverTicket,
        setHandoverTicket,
        loading,
        setLoading,
        approvalProcessTimeLine,
        setApprovalProcessTimeLine,
        screens
      }}
    >
      {children}
    </OfficeTicketDetailContext.Provider>
  );
};
